import { AvField, AvForm } from "availity-reactstrap-validation";
import React, { Component } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button, Col, FormGroup, Label, Row } from "reactstrap";
//Import actions redux
import { updatePararamGroup } from "../../store/actions";
import Loader from "../Common/Loader";

// const types = [
//   { name: "Esperar", value: "WAIT" },
//   { name: "Liberar", value: "FREE" },
// ];

class GlobalParamsForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      params: this.props.params,
      editable: this.props.editable,
      loading: false,
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  // handleValidSubmit
  handleValidSubmit(event, values) {
    console.log(values);
    this.props.updatePararamGroup(values, this.state.user, this.props.history);
  }
  componentDidUpdate(prevProps) {
    if (this.props.editable !== prevProps.editable) {
      this.setState({ editable: this.props.editable });
    }
    // this.props.params.map((p) => console.log(p.param_name));
  }

  render() {
    if (this.props.loadingUpdateParamGroup) {
      return (
        <React.Fragment>
          <Loader></Loader>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <AvForm
          className="needs-validation"
          onValidSubmit={this.handleValidSubmit}
        >
          <Row className="row">
            {this.state.params.map((param, index) => {
              let type = param.param_name.split(["_"])[0];
              let disable =
                type === "MaxTaskToSend" && this.state.user.role_id > 1;
              //make a condition if param_name is LOGGER_LEVEL to show a select else show a input
              if (param.param_name === "LOGGER_LEVEL") {
                return (
                  <React.Fragment key={index}>
                    <Col className="col-6">
                      <FormGroup>
                        <Label htmlFor="validationCustom01">
                          {this.props.t(param.param_name)}
                        </Label>
                        <AvField
                          name={param.param_name}
                          placeholder={
                            this.props.t("Introduce ") +
                            this.props.t(param.param_name)
                          }
                          type="select"
                          value={param.param_actual_value}
                          errorMessage={this.props.t(
                            "Introduzca un valor válido"
                          )}
                          className="form-control"
                          disabled={disable || !this.state.editable}
                        >
                          <option value="info">INFO</option>
                          <option value="error">ERROR</option>
                        </AvField>
                      </FormGroup>
                    </Col>
                  </React.Fragment>
                );
              } else if (param.param_name === "PRIO_STRICT_MODE") {
                return (
                  <React.Fragment key={index}>
                    <Col className="col-6">
                      <FormGroup>
                        <Label htmlFor="validationCustom01">
                          {this.props.t(param.param_name)}
                        </Label>
                        <AvField
                          name={param.param_name}
                          placeholder={
                            this.props.t("Introduce ") +
                            this.props.t(param.param_name)
                          }
                          type="select"
                          value={param.param_actual_value}
                          errorMessage={this.props.t(
                            "Introduzca un valor válido"
                          )}
                          className="form-control"
                          disabled={disable || !this.state.editable}
                        >
                          <option value="1">{this.props.t("YES")}</option>
                          <option value="0">{this.props.t("NO")}</option>
                        </AvField>
                      </FormGroup>
                    </Col>
                  </React.Fragment>
                );
              }
              return (
                <React.Fragment key={index}>
                  <Col className="col-6">
                    <FormGroup>
                      <Label htmlFor="validationCustom01">
                        {this.props.t(param.param_name)}
                      </Label>
                      <AvField
                        name={param.param_name}
                        placeholder={
                          this.props.t("Introduce ") +
                          this.props.t(param.param_name)
                        }
                        type="text"
                        value={param.param_actual_value}
                        errorMessage={this.props.t(
                          "Introduzca un valor válido"
                        )}
                        className="form-control"
                        readOnly={disable || !this.state.editable}
                      />
                    </FormGroup>
                  </Col>
                </React.Fragment>
              );
            })}
          </Row>

          <Button color="primary" type="submit" disabled={!this.state.editable}>
            {this.props.t("Modificar parametros")}
          </Button>
        </AvForm>
      </React.Fragment>
    );
  }
}

const mapStateprops = (state) => {
  const { loadingUpdateParamGroup } = state.UpdateParamGroup;
  return { loadingUpdateParamGroup };
};
export default withRouter(
  connect(mapStateprops, { updatePararamGroup })(
    withNamespaces()(GlobalParamsForm)
  )
);
